import React from 'react';
import styled from 'styled-components';
import PartnerBusinessCardLoader from '../PartnerBusinessCard/PartnerBusinessCardLoader';
import mapContext from '../../../contexts/map-context';

export type Props = {
  dealerId: string;
};

export const MobileDealerDetails = ({ dealerId }: Props) => {
  const { dealerRatings, favoritePartner } = mapContext.useMapState();

  const fiveStarRating = dealerRatings?.[dealerId];

  const openDialog = () => {
    const body = document.querySelector('body');

    if (body) {
      body.style.overflow = 'hidden';
    }
  };

  return (
    <PbcContainer>
      <PartnerBusinessCardLoader
        partnerID={dealerId}
        fiveStarRating={fiveStarRating}
        isMobile
        favoritePartner={favoritePartner}
        openDialog={openDialog}
      />
    </PbcContainer>
  );
};

const PbcContainer = styled.div.attrs({ 'data-test-id': 'mobile-dealer-details-component' })`
  width: 100%;
  min-height: auto;
  padding: 24px;
  padding-bottom: ${24 * 2}px;
  box-sizing: border-box;
`;
